export default function BoldIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.62"
      height="14"
      viewBox="0 0 10.62 14"
    >
      <g data-name="Icon - Bold">
        <path
          fill="currentColor"
          d="M9.3-7.141a3.136 3.136 0 011.94 1.183A3.462 3.462 0 0112-3.751a3.563 3.563 0 01-.55 1.976A3.665 3.665 0 019.86-.441 5.811 5.811 0 017.4.04H1.38v-14h5.76a5.959 5.959 0 012.45.461 3.491 3.491 0 011.56 1.284 3.368 3.368 0 01.53 1.865 3.2 3.2 0 01-.65 2.05A3.477 3.477 0 019.3-7.141zM4.18-8.183h2.56a2.339 2.339 0 001.54-.451 1.591 1.591 0 00.54-1.294 1.621 1.621 0 00-.54-1.3 2.3 2.3 0 00-1.54-.461H4.18zM7-2.247a2.391 2.391 0 001.59-.481 1.687 1.687 0 00.57-1.364 1.759 1.759 0 00-.6-1.414 2.415 2.415 0 00-1.62-.511H4.18v3.771z"
          data-name="Path 10406"
          transform="translate(-1.38 13.96)"
        ></path>
      </g>
    </svg>
  );
}
